import { UseFormSetFocus, UseFormSetValue } from 'react-hook-form';

import { RendererOption } from '@/shared-project-response-message-renderers';

import { MessageFormValues } from './project-response.hooks';

export function focusContentFieldWhenEnabled({
  disabled,
  setFocus,
}: {
  disabled: boolean | undefined;
  setFocus: UseFormSetFocus<MessageFormValues>;
}): void {
  if (!disabled) setFocus('content');
}

export function shouldClearContentOnQuestionTypeChange(
  prevType: RendererOption | null | undefined,
  questionType: RendererOption | null | undefined
): boolean {
  return (
    questionType !== prevType &&
    questionType !== 'openEnded' &&
    prevType !== undefined
  );
}

export function clearContentOnQuestionTypeChange({
  prevTypeRef,
  questionType,
  setValue,
}: {
  prevTypeRef: React.RefObject<RendererOption | null | undefined>;
  questionType: RendererOption | null | undefined;
  setValue: UseFormSetValue<MessageFormValues>;
}): void {
  if (
    shouldClearContentOnQuestionTypeChange(prevTypeRef.current, questionType)
  ) {
    setValue('content', '');
  }

  prevTypeRef.current = questionType;
}
